module.exports = __webpack_public_path__ + "static/media/6.69dcc73e.jpg";